import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';

export const SUPPORTED_LANGS = ['fr', 'en', 'de', 'es', 'it', 'nl', 'pl'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export function toSupportedLang(candidate: string | null | undefined): SupportedLang {
  const lang = (candidate ?? '').slice(0, 2).toLowerCase();
  return (SUPPORTED_LANGS as readonly string[]).includes(lang) ? (lang as SupportedLang) : 'fr';
}

/** Détection : ?lang=xx prioritaire, sinon langue navigateur, sinon fr. */
function detectLanguage(): SupportedLang {
  const fromQuery = new URLSearchParams(window.location.search).get('lang');
  return toSupportedLang(fromQuery ?? navigator.language);
}

void i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
    it: { translation: it },
    nl: { translation: nl },
    pl: { translation: pl },
  },
  lng: detectLanguage(),
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

export default i18n;
